import React, { Dispatch, SetStateAction } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { PostAmountActions } from '../../../../../redux/reducers/postAmount';
import { RootState } from '../../../../../redux/store';
import { Spinner } from 'react-bootstrap';
import { useQueryClient } from 'react-query';

export type LoadMoreProps = {};
const LoadMore = ({}: LoadMoreProps) => {
  const dispatch = useDispatch();
  const postAmountState = useSelector(
    ({ postAmountState }: RootState) => postAmountState
  );

  const queryClient = useQueryClient();
  const userId = useSelector(({ userState }: RootState) => userState.user?.id);
  const spaceId = useSelector(
    ({ spaceState }: RootState) => spaceState.currentSpaceId
  );
  const isPostFetching =
    queryClient.getQueryState([
      'space_posts',
      spaceId,
      userId,
      postAmountState.amount,
    ])?.status === 'idle';

  return postAmountState.addingPostIsLoading ? (
    <div className="flex justify-center items-center mb-4">
      <button className="bg-sky-500 w-1/4 text-white font-bold py-2 px-4 rounded">
        <Spinner size="sm" />
      </button>
    </div>
  ) : (
    <div className="flex justify-center items-center mb-4">
      <button
        onClick={() => {
          dispatch({
            type: PostAmountActions.SetAmount,
            payload: { amount: postAmountState.amount + 25 },
          });
        }}
        className={`bg-neon-blue w-1/4 hover:bg-sky-500 text-white font-bold py-2 px-4 rounded ${
          isPostFetching ? 'cursor-not-allowed bg-sky-300' : ''
        }}`}
      >
        {isPostFetching ? 'Loading...' : 'Load More'}
      </button>
    </div>
  );
};

export default LoadMore;
